import React, { useRef } from 'react';
import { Cascader as RSCascader, CascaderProps as RSCascaderProps } from 'rsuite';
import { FieldProps } from 'formik';

export interface CascaderProps extends Omit<RSCascaderProps, 'form'>, FieldProps {}

export default function Cascader({
  field,
  form,
  placeholder = ' ',
  data,
  ...props
}: CascaderProps) {
  const pickerRef = useRef(null);
  const { labelKey = 'label' } = props;
  const handleChange = (value, event) => {
    form.setFieldValue(field.name, value || '');
  };
  const handleSelect = (children, value) => {
    //没有子级直接勾选
    if (!children || children?.length === 0) {
      form.setFieldValue(field.name, value);
      pickerRef.current?.close();
    }
  };

  return (
    <RSCascader
      ref={pickerRef}
      placeholder={placeholder}
      data={data}
      name={field.name}
      value={field.value}
      onChange={handleChange}
      onSelect={(item) => handleSelect(item[props?.childrenKey ?? 'children'], item.value)}
      parentSelectable={true}
      renderMenuItem={(label, item): React.ReactNode => <span title={item[labelKey]}>{label}</span>}
      {...props}
    />
  );
}
